import { render, staticRenderFns } from "./PriorityIcon.vue?vue&type=template&id=b201cda8&scoped=true&"
import script from "./PriorityIcon.vue?vue&type=script&setup=true&lang=js&"
export * from "./PriorityIcon.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PriorityIcon.vue?vue&type=style&index=0&id=b201cda8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b201cda8",
  null
  
)

export default component.exports